import { PaginationType } from "@/types/common";

export const UNDEFINED_VALUE = "-";

// Format
export const FM_FULL_DATE = "DD/MM/YYYY HH:mm";
export const FM_SHORT_DATE = "DD/MM/YYYY";
export const FM_FULL_HOUR = "HH:mm:ss";

// Pagination
export const ARR_PAGINATION = [5, 10, 15];

export const DEFAULT_SIZE_PAGE = 10;

export const DEFAULT_PAGINATION: PaginationType = {
  page: 1,
  size: DEFAULT_SIZE_PAGE,
  total: 0,
  totalPage: 1,
};

// Select
export const SELECT_ALL = "app-select-all";

// Form
export const ACCEPT_IMAGE_MIME_TYPES = ["image/png", "image/jpeg", "image/jpg", "image/svg+xml"];

export const ACCEPT_ZIP_TYPE = [
  "application/zip",
  "application/x-zip-compressed",
  "multipart/x-zip",
  "application/octet-stream",
];
